<div class="main-content pt-0">
    <div class="container-fluid">
        <h1 style="font-family: Arial, Helvetica, sans-serif !important;"> Hello, {{dasboardDetails.name}}</h1>
        <div class="row my-5">
            <div class="col-md-12" *ngIf="paymentRedirectUrl">
                Click <a class="text-info text-bold" (click)="openAttemptWindow(paymentRedirectUrl)">here</a> if Exam page does not open: ensure that pop-up blocker is disabled in broswer settings.
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mt-3">
                <div class="h-100 card">
                    <div class="d-flex justify-content-center align-items-center p-5">
                        <img width="64" height="64" src="../../assets/assets/images/coin.png">
                        <div class="header d-flex flex-column justify-content-center" *ngIf="!loading">
                            <h5 class="text-center">{{creditText}} Attempt(s) Left</h5>
                            <p class="text-center text-uppercase"><span class="badge badge-success"
                                    *ngIf="creditActive && showCreditsBadge">Active</span></p>
                            <p class="text-center text-uppercase"><span class="badge badge-danger"
                                    *ngIf="!creditActive && showCreditsBadge">Expired</span></p>
                            <p class="text-center text-uppercase"
                                *ngIf="dasboardDetails.creditExpiryDate && showCreditsBadge">Valid until
                                {{this.util.formatDate(dasboardDetails.creditExpiryDate)}}</p>                               
                        </div>
                    </div>     
                    <p class="text-center text-uppercase category">Total Attempts: {{dasboardDetails.totalAttempts}}
                    </p>                
                    <div class="content" *ngIf="loading">
                        <div class="d-flex justify-content-center align-item-center">
                            <i class="fa fa-spinner spin-icon spinner" style="font-size: large ;"></i>
                        </div>
                        <p class="text-center">loading</p>
                    </div>
                    <div class="content">
                        <div class="d-flex justify-content-center mt-5 text-center">
                            <button [style]="style.btnstyle" class="btn" (click)="takeAttempt()"
                                [disabled]="btnClicked||dasboardDetails.credits == 0 || !creditActive">Take
                                Test</button>
                            <button *ngIf="dasboardDetails.credits == 0 || !creditActive" [style]="style.btnstyle" class="btn ml-2" routerLink="/upgrade" >Buy Credits</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 mt-3">
                <div class="card h-100">
                    <div class="header">
                        <h5 style="text-align: center;">Previous Attempt</h5>
                    </div>
                    <div class="content" *ngIf="subjects && previousAttempt">
                        <div *ngFor="let subject of subjects">
                            <div class="d-flex justify-content-between">
                                <p class="m-0">{{subject.sub}}</p>
                                <p class="m-0">{{subject.score|number}}</p>
                            </div>
                            <div class="gauge-fill mb-2" [style.width.%]="subject.percentagescore" [style]="style.gaugestyle"> </div>
                        </div>
                        <h3 class="text-center">Total: {{previousAttempt.score|number}} </h3>    
                        <div class="d-flex justify-content-end">
                            <a href="/attempts-history">view more history</a>
                        </div>
                    </div>
                    <div class="content" *ngIf="loading">
                        <div class="d-flex justify-content-center align-item-center">
                            <i class="fa fa-spinner spin-icon spinner" style="font-size: large ;"></i>
                        </div>
                        <p class="text-center">loading</p>
                    </div>
                    <p class="text-center pt-3" *ngIf="subjects.length<=0">You have no attempt record yet.</p>
                    
                </div>
            </div>
        </div>
        
        <div class="row mt-5">

            <div class="col-md-12">

            </div>

        </div>
        <div class="row">

            <div class="col-md-12" *ngIf="!loading">
                <lbd-chart [title]="'Previous Assessment Scores'" [subtitle]="'Last 5 Attempts'" [message]="message"
                    [chartType]="hoursChartType" [chartData]="hoursChartData" [chartOptions]="hoursChartOptions"
                    [chartResponsive]="hoursChartResponsive" [legendItems]="hoursChartLegendItems" [withHr]="false"
                    [footerIconClass]="" [footerText]="''">
                </lbd-chart>
            </div>
            <div class="col-md-12 content mt-5 card" *ngIf="loading">
                <div class="header">
                    <h5 class="title">Previous Assessment Scores</h5>
                    <p class="category">Last 5 Attempts</p>
                </div>
                <div class="d-flex justify-content-center align-item-center">
                    <i class="fa fa-spinner spin-icon spinner" style="font-size: large ;"></i>
                </div>
                <p class="text-center">loading</p>
            </div>
        </div>
    </div>

</div>